import { useContext } from 'react';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';

export const useActivityTracking = () => {
    const namespace = useContext(CommunicationContext);

    return namespace.components.travel.activityScoreTracking;
};
